const data = 
[
    {
        "brand": "GoPro",
        "camera": "GoPro5",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.60",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro相机开蓝牙步骤：开机后请确认相机在拍照模式，主页面下滑-连接-连接新的设备-Capture App\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音。\n4、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。 \n5、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro6",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.01",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro相机开蓝牙步骤：开机后请确认相机在拍照模式，主页面下滑-连接-连接新的设备-GoPro应用\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音。\n4、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n5、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 SILVER",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.00",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro相机开蓝牙步骤：主页面下滑-偏好-连接-连接至GoPro应用\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音。\n4、GoPro相机手动返回主界面\n5、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n6、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 Black",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.90",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro相机开蓝牙步骤：开机后请确认相机在视频模式，主页面下滑-首选项-连接-连接设备-GoPro应用\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙出现“GoPro ****\"。点击GoPro蓝牙进行连接，连接成功后GoPro相机会发出提示音。\n4、听到GoPro相机发出提示音后，请单击云台拍摄键(此时GoPro相机发出滴的一声）\n5、GoPro相机单击返回箭头且一直等待“已停止配对”消失，再手动返回相机主界面。\n6、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n7、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 White",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.10",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro相机开蓝牙步骤：主页面下滑-偏好-连接-连接至GoPro应用\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3.等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音。\n4、GoPro相机手动返回主界面\n5、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n6、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro8 Black",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.51",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro开蓝牙步骤：开机后请确认相机在拍照模式，主页面下滑-首选项-连接-连接设备-遥控器（或者进“GoPro应用”)\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音，并显示\"连接成功\"。\n4、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n5、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro9 Black",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.72",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro相机开蓝牙步骤：主页面下滑-再左滑-连接-连接设备-The Remote（或者进“Quik应用”)\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音，并显示\"连接成功\"。\n4、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n5、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro10",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.46",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro开蓝牙步骤：主页面下滑再左滑-连接-连接设备-The Remote（或者进“GoPro Quik应用”）\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音，并显示\"连接成功\"。\n4、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n5、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro11",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.12",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro开蓝牙步骤：主页面下滑再左滑-首选项-无线连接-连接设备-The Remote遥控器（或者进“GoPro Quik应用”）\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音，并显示\"连接成功\"。\n4、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n5、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    },
    {
        "brand": "GoPro",
        "camera": "GoPro Max",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.00",
        "blueToothFirmware": "1.09",
        "note": "1、GoPro开蓝牙步骤：主页面下滑-首选项-连接-连接设备-遥控器（或者进“GoPro 应用”）\n2、打开云台后，主屏右侧边缘从右往左滑，选择更多设置，点击蓝牙设置，打开云台蓝牙\n3、等待GoPro相机蓝牙“GoPro ****\"出现。点击GoPro相机蓝牙进行连接，连接成功后GoPro相机会发出提示音，并显示\"连接成功\"。\n4、云台返回主界面，并确认左上角出现相机图标，即可通过云台拍摄键控制相机拍照（长按3秒）/录像（短按）。\n5、请确认云台的云台固件/手柄固件/电机驱动的固件都在1.09或以上版本，并且蓝牙板固件为1.03或以上。"
    }
]

export default data